import { gql } from "@apollo/client";
import moment from 'moment';

export const GET_DOCUMENTOS_CONTRATO = gql`
query allDocumentosContrato ($idEvaluacion: Int! ){
  allDocumentosContrato( idEvaluacion: $idEvaluacion ){
    idArchivo
    idTipoArchivoDocumento
    titulo
    fechaAlta
  }
}`;

export const adaptDocumento = (documento) => ({
  idArchivo: documento?.idArchivo,
  idTipoArchivoDocumento: documento?.idTipoArchivoDocumento,
  titulo: documento?.titulo,
  fechaAlta: moment(documento?.fechaAlta).format('L LTa')
});

export const adaptDocumentoArray = (documentos) =>
documentos?.allDocumentosContrato?.map((documento) => structuredClone(adaptDocumento(documento)));